import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-booking-cart-details",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./booking-cart-details.component.html",
  styleUrl: "./booking-cart-details.component.scss"
})
export class BookingCartDetailsComponent implements OnChanges {
  @Input() bookingDetails: any;

  decimalPointValue: number = 0;
  setCurrencySign: number = 1;

  constructor(public helper: Helper) {}

  /**
   * Lifecycle hook that is called when any data-bound property of a directive changes.
   * Updates the decimalPointValue and setCurrencySign based on the bookingDetails input.
   *
   * @param changes The changes in the input properties.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["bookingDetails"]) {
      this.decimalPointValue = this.bookingDetails.decimalPointValue ?? this.bookingDetails.bookingInvoice?.decimalPointValue;
      this.setCurrencySign = this.bookingDetails.setCurrencySign ?? this.bookingDetails.bookingInvoice?.setCurrencySign;
    }
  }

  /**
   * Handles the error event for product images.
   * Sets the default user image if the image fails to load.
   *
   * @param event The error event triggered by the image element.
   * @param imageUrl The URL of the image that failed to load.
   */
  handleProductImageError(event: any, imageUrl: any): void {
    event.target.src = this.helper.DefaultImages.DefaultUserImage;
    if (imageUrl) {
      imageUrl = "";
    }
  }

  /**
   * Constructs the variant name based on the unit value, unit type, and unit quantity.
   *
   * @param variant The variant object containing unit details.
   * @returns The constructed variant name.
   */
  getVarientName(variant: any): any {
    let variantName = `${variant.unitValue} ${variant.unitType}`;
    if (variant.unitQty > 1) {
      variantName = `${variant.unitQty} X ${variant.unitValue} ${variant.unitType}`;
    }
    return variantName;
  }
}
